<template>
  <div id="view">
    <div class="head">
      <div class="left">
        <div class="head_icon">
          <span :class="icon"></span>
        </div>
        <div class="title">
          {{ title }}
        </div>
        <div class="en_title">{{ enTitle }}</div>
      </div>
      <div class="right">
        <span
          class="click_more"
          @click="
            $router.push(
              '/ArticleInit/list?articleModel=' +
                articleModel +
                '&isHomePage=' +
                isHomePage
            )
          "
          >更多>></span
        >
      </div>
    </div>
    <div class="articl_list">
      <ul>
        <li
          v-for="item in articleList"
          @click="
            $router.push(
              '/ArticleInit/detail?articleId=' +
                item.articleId +
                '&articleModel=' +
                item.articleModel
            )
          "
        >
          <div class="date">
            <div>
              <div class="date_month">{{ item.dateStr.substr(5, 2) }}</div>
              <div class="date_day">{{ item.dateStr.substr(8, 2) }}</div>
            </div>
          </div>
          <div class="title">
            <span>{{ item.articleTitle }}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { apiService, RESULT_CODE } from "@/api/ApiService.js";
export default {
  name: "ArcicleListWindowThree",
  data() {
    return {
      articleList: []
    };
  },
  props: ["icon", "title", "articleModel", "enTitle", "isHomePage"],
  mounted() {
    let articleModel = this.articleModel;
    let isHomePage = this.isHomePage;
    apiService
      .findArticle({ articleModel, isHomePage, pageNum: 1, pageSize: 9 })
      .then(res => {
        if (res.code == RESULT_CODE.SUCCESS) {
          this.articleList = res.rows;
        }
      });
  }
};
</script>
<style scoped>
#view {
  display: flex;
  flex-direction: column;
  user-select: none;
}

.head {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #6510ad;
  padding-bottom: 10px;
}

.click_more {
  white-space: nowrap;
  font-size: 14px;
  display: inline-block;
  position: absolute;
  right: 10px;
  bottom: 5px;
  cursor: pointer;
}

.en_title {
  margin-left: 10px;
}

.head > .left {
  display: flex;
}

.head > .left {
  font-size: 0.125rem;
  font-weight: 700;
  line-height: 00.125rem;
}

.head_icon {
  margin-right: 5px;
}

.head_icon > span {
  font-weight: 700;
  color: #23487e;
}

.head > .right {
  position: relative;
}

.head > .right > span {
  position: absolute;
  bottom: 0;
  right: 0;
}

.head > .right > span > a {
  text-decoration: none;
  font-size: 0.07rem;
  width: 0.28rem;
  display: inline-block;
  color: #2c3e50;
}

.articl_list {
  margin-top: 10px;
  padding: 0 5px;
  flex: 1;
}

.articl_list > ul {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.articl_list li {
  display: flex;
  border-bottom: 1px solid #e5e5e5;
  line-height: 0.25rem;
  cursor: pointer;
}

.articl_list li > .title {
  flex: 1;
  font-size: 0.08rem;
  height: 0.25rem;
}

.articl_list li > .title > span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #464646;
  width: 100%;
  display: inline-block;
}

.articl_list li > .date {
  width: 0.45rem;
  text-align: center;
  position: relative;
}

.date > div {
  line-height: 0.1rem;
  width: 0.3rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  border-radius: 0.05rem 0.025rem 0.025rem 0.05rem;
  border: 1px solid #004ea2;
  display: flex;
  overflow: hidden;
}

.date .date_month {
  flex: 1;
  background-color: #fff;
  color: #004ea2;
  font-weight: 700;
}

.date .date_day {
  flex: 1;
  background-color: #004ea2;
  color: #fff;
}

/* 应用于视口宽度小于 768px 的情况 */
@media (max-width: 767px) {
  /* 在此处添加样式 */
  .title {
    max-width: 80%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ArticleListWindowThree.vue